module.exports = __webpack_public_path__ + "static/insights-99ebe203880efdbc99c137421b4d0503.svg";